var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.875 4c0-.242.196-.437.438-.437H11.63L8.878.809a.438.438 0 0 1 .619-.618l3.5 3.5c.17.17.17.447 0 .618l-3.5 3.5a.438.438 0 0 1-.619-.618l2.753-2.753H1.313A.44.44 0 0 1 .875 4",
    clipRule: "evenodd"
  })));
};
export default SvgArrowRight;